<template>
    <div id="wp-side-menu-bar">
        <router-link to="/integrations/whatsapp" :class="{ active: selectedPage === 'integration' }" class="menu">
            {{ $t("chatbotv2.integration") }}
        </router-link>
        <router-link
            to="/integrations/whatsapp/contact-list"
            :class="{ active: selectedPage === 'contact-list' }"
            class="menu"
        >
            {{ $t("wp.contactList") }}
        </router-link>
        <router-link
            to="/integrations/whatsapp/broadcast/requests"
            :class="{ active: selectedPage === 'broadcast' }"
            class="menu"
        >
            {{ $t("wp.broadcast.broadcast") }}
        </router-link>
        <router-link
            to="/integrations/whatsapp/broadcast/requests"
            :class="{ hidden: selectedPage !== 'broadcast', active: selectedSubPage === 'requests' }"
            class="menu sub-menu"
        >
            {{ $t("wp.broadcastRequests") }}
        </router-link>
        <router-link
            to="/integrations/whatsapp/broadcast/customer-groups"
            :class="{ hidden: selectedPage !== 'broadcast', active: selectedSubPage === 'customer-groups' }"
            class="menu sub-menu"
        >
            {{ $t("wp.customerGroups") }}
        </router-link>
        <router-link
            to="/integrations/whatsapp/broadcast/message-templates"
            :class="{ hidden: selectedPage !== 'broadcast', active: selectedSubPage === 'message-templates' }"
            class="menu sub-menu"
        >
            {{ $t("wp.messageTemplates") }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: "WhatsappMenu",
    props: {
        selectedPage: {
            type: String,
        },
        selectedSubPage: {
            type: String,
        },
    },
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style lang="scss">
#wp-side-menu-bar {
    background-color: #f5f8fb;
    box-shadow: inset -7px -1px 25px -5px #d1dfec;
    padding: 20px 30px;
    height: 100%;

    .ant-menu-inline {
        border: none;
        background-color: transparent;

        li {
            .ant-menu-submenu-title {
                padding: 0 !important;
                margin: 0 !important;

                i {
                    display: none;
                }
            }

            ul {
                background-color: transparent !important;

                .ant-menu-item {
                    padding-left: 0px !important;
                }
            }
        }
    }

    .menu {
        word-wrap: break-word;
        color: #22272d;
        max-width: 100%;
        padding: 5px 0;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s;
        display: block;

        &:hover {
            color: #008aff;
            opacity: 0.8;
        }

        &.active {
            color: #008aff;
            opacity: 0.8;
        }
    }

    .sub-menu {
        margin-left: 1rem;
        font-weight: 400;
        padding: 0;

        &.active {
            color: #008aff;
            opacity: 0.8;
        }

        &.hidden {
            display: none;
        }
    }

    //.router-link-active {
    //    color: #008aff;
    //    opacity: 0.8;
    //}
}
</style>
